import { BaseInteractiveElement } from './component-base.js';

class ToggleCardElement extends BaseInteractiveElement {
  constructor() {
    super({ baseClass: '', eventGroup: undefined });
    this._onClick = this._onClick.bind(this);
  }
  connectedCallback() {
    try {
      super.connectedCallback();
      this.addEventListener('click', this._onClick, true);
      this.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this._onClick(e); } }, true);
      this._applyState(this.hasAttribute('data-open'));
    } catch (_) {}
  }
  disconnectedCallback() {
    try { this.removeEventListener('click', this._onClick, true); } catch (_) {}
    try { super.disconnectedCallback(); } catch (_) {}
  }
  _applyState(open) {
    try {
      this.toggleAttribute('data-open', !!open);
      this.setAttribute('aria-expanded', String(!!open));
      const group = this.closest('.group') || this.parentElement;
      if (group && group.classList && group.toggleAttribute) {
        // no-op for attributes; class-based transitions rely on group-data-[open]
      }
      // Icon swap
      const plus = this.querySelector('[data-tc-icon-plus]');
      const minus = this.querySelector('[data-tc-icon-minus]');
      if (plus && minus) {
        if (open) { plus.classList.add('hidden'); minus.classList.remove('hidden'); }
        else { plus.classList.remove('hidden'); minus.classList.add('hidden'); }
      }
    } catch (_) {}
  }
  _onClick(ev) {
    try {
      // ignore clicks on inner links/buttons
      const inner = ev.target && ev.target.closest && ev.target.closest('a,button');
      if (inner && this.contains(inner)) return;
      // If activator is restricted to icon, only toggle when clicking inside marked activator
      const activatorMode = this.getAttribute('data-activator');
      if (activatorMode === 'icon') {
        const act = ev.target && ev.target.closest && ev.target.closest('[data-tc-activator]');
        if (!act || !this.contains(act)) return;
      }
      const isOpen = this.hasAttribute('data-open');
      const willOpen = !isOpen;
      // If single-open behavior is enabled on an ancestor, close siblings first
      if (willOpen) {
        try {
          let scope = this.closest('[data-toggle-card-single],[single-expand]');
          if (!scope) scope = this.closest('.layout-grid');
          if (scope) {
            const openCards = scope.querySelectorAll('toggle-card[data-open]');
            openCards.forEach((el) => {
              if (el === this) return;
              try { typeof el._applyState === 'function' ? el._applyState(false) : el.removeAttribute('data-open'); } catch (_) {}
            });
          }
        } catch (_) {}
      }
      this._applyState(willOpen);
      ev.preventDefault && ev.preventDefault();
      ev.stopPropagation && ev.stopPropagation();
    } catch (_) {}
  }
}

try {
  const TAG = 'toggle-card';
  if (!customElements.get(TAG)) customElements.define(TAG, ToggleCardElement);
} catch (_) {}


